import React from "react";

import { Provider } from "react-redux";

import PartnerProvider from "Common/PartnerProvider";

import createStore from "./createStore";
import EmployeeApplication from "./EmployeeApplication";
import { adminEmployeeParam } from "./urls";

import type { State, Action } from "./createStore";
import type { Store } from "redux";

class EmployeeApplicationApp extends React.Component<Props> {
  store: Store<State, Action>;

  constructor(props) {
    super(props);
    this.store = createStore({
      employeeHashId: props.match.params[adminEmployeeParam],
    });
  }

  render() {
    return (
      <Provider store={this.store}>
        <PartnerProvider>
          <EmployeeApplication match={this.props.match} />
        </PartnerProvider>
      </Provider>
    );
  }
}

export default EmployeeApplicationApp;
